/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BillingControllerGetQuotaParams,
  BillingControllerPreviewWhiteGlovePromotionParams,
  ChangePlanDto,
  ChangePlanResponseDto,
  CheckoutSessionResponseDto,
  ClientQuotaStatusResponseDto,
  ConfirmAddonDto,
  ConfirmShopifyBillingDto,
  ConfirmSubscriptionDto,
  CreateCheckoutDto,
  ExportQuotaStatusResponseDto,
  FigmaPluginStatusResponseDto,
  InlineSubscribeDto,
  InlineSubscribeResponseDto,
  MessageResponseDto,
  PlanListResponseDto,
  PortalSessionResponseDto,
  QuotaStatusResponseDto,
  ResumeAddonPaymentResponseDto,
  SetBrandTiersDto,
  SetBrandTiersResponseDto,
  SetupIntentResponseDto,
  ShopifyBillingStatusResponseDto,
  ShopifySubscribeUrlResponseDto,
  SubscriptionResponseDto,
  UpdatePaymentMethodDto,
  WhiteGlovePromotionPreviewDto,
} from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary List active plans
 */
export const billingControllerGetPlans = (
  orgId: unknown,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<PlanListResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/plans`, method: 'GET', signal },
    options
  );
};

export const getBillingControllerGetPlansQueryKey = (orgId?: unknown) => {
  return [`/api/v1/organizations/${orgId}/billing/plans`] as const;
};

export const getBillingControllerGetPlansQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetPlans>>,
  TError = unknown,
>(
  orgId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetPlans>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetPlansQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetPlans>>> = ({
    signal,
  }) => billingControllerGetPlans(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetPlans>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetPlansQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetPlans>>
>;
export type BillingControllerGetPlansQueryError = unknown;

export function useBillingControllerGetPlans<
  TData = Awaited<ReturnType<typeof billingControllerGetPlans>>,
  TError = unknown,
>(
  orgId: unknown,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetPlans>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetPlans>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetPlans<
  TData = Awaited<ReturnType<typeof billingControllerGetPlans>>,
  TError = unknown,
>(
  orgId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetPlans>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetPlans>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetPlans>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetPlans<
  TData = Awaited<ReturnType<typeof billingControllerGetPlans>>,
  TError = unknown,
>(
  orgId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetPlans>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List active plans
 */

export function useBillingControllerGetPlans<
  TData = Awaited<ReturnType<typeof billingControllerGetPlans>>,
  TError = unknown,
>(
  orgId: unknown,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetPlans>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetPlansQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get current organization subscription
 */
export const billingControllerGetSubscription = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SubscriptionResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/subscription`, method: 'GET', signal },
    options
  );
};

export const getBillingControllerGetSubscriptionQueryKey = (orgId?: string) => {
  return [`/api/v1/organizations/${orgId}/billing/subscription`] as const;
};

export const getBillingControllerGetSubscriptionQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetSubscription>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetSubscription>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetSubscriptionQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetSubscription>>> = ({
    signal,
  }) => billingControllerGetSubscription(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetSubscription>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetSubscriptionQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetSubscription>>
>;
export type BillingControllerGetSubscriptionQueryError = unknown;

export function useBillingControllerGetSubscription<
  TData = Awaited<ReturnType<typeof billingControllerGetSubscription>>,
  TError = unknown,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetSubscription>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetSubscription>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetSubscription<
  TData = Awaited<ReturnType<typeof billingControllerGetSubscription>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetSubscription>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetSubscription>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetSubscription>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetSubscription<
  TData = Awaited<ReturnType<typeof billingControllerGetSubscription>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetSubscription>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get current organization subscription
 */

export function useBillingControllerGetSubscription<
  TData = Awaited<ReturnType<typeof billingControllerGetSubscription>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetSubscription>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetSubscriptionQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create Stripe Checkout session for new subscription
 */
export const billingControllerCreateCheckout = (
  orgId: string,
  createCheckoutDto: CreateCheckoutDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<CheckoutSessionResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/checkout`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createCheckoutDto,
      signal,
    },
    options
  );
};

export const getBillingControllerCreateCheckoutMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerCreateCheckout>>,
    TError,
    { orgId: string; data: CreateCheckoutDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerCreateCheckout>>,
  TError,
  { orgId: string; data: CreateCheckoutDto },
  TContext
> => {
  const mutationKey = ['billingControllerCreateCheckout'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerCreateCheckout>>,
    { orgId: string; data: CreateCheckoutDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerCreateCheckout(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerCreateCheckoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerCreateCheckout>>
>;
export type BillingControllerCreateCheckoutMutationBody = CreateCheckoutDto;
export type BillingControllerCreateCheckoutMutationError = unknown;

/**
 * @summary Create Stripe Checkout session for new subscription
 */
export const useBillingControllerCreateCheckout = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerCreateCheckout>>,
      TError,
      { orgId: string; data: CreateCheckoutDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerCreateCheckout>>,
  TError,
  { orgId: string; data: CreateCheckoutDto },
  TContext
> => {
  const mutationOptions = getBillingControllerCreateCheckoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create inline subscription (returns client secret for PaymentElement)
 */
export const billingControllerSubscribe = (
  orgId: string,
  inlineSubscribeDto: InlineSubscribeDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<InlineSubscribeResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/subscribe`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inlineSubscribeDto,
      signal,
    },
    options
  );
};

export const getBillingControllerSubscribeMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerSubscribe>>,
    TError,
    { orgId: string; data: InlineSubscribeDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerSubscribe>>,
  TError,
  { orgId: string; data: InlineSubscribeDto },
  TContext
> => {
  const mutationKey = ['billingControllerSubscribe'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerSubscribe>>,
    { orgId: string; data: InlineSubscribeDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerSubscribe(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerSubscribeMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerSubscribe>>
>;
export type BillingControllerSubscribeMutationBody = InlineSubscribeDto;
export type BillingControllerSubscribeMutationError = unknown;

/**
 * @summary Create inline subscription (returns client secret for PaymentElement)
 */
export const useBillingControllerSubscribe = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerSubscribe>>,
      TError,
      { orgId: string; data: InlineSubscribeDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerSubscribe>>,
  TError,
  { orgId: string; data: InlineSubscribeDto },
  TContext
> => {
  const mutationOptions = getBillingControllerSubscribeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Confirm inline subscription after payment succeeds
 */
export const billingControllerConfirmSubscription = (
  orgId: string,
  confirmSubscriptionDto: ConfirmSubscriptionDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/subscribe/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmSubscriptionDto,
      signal,
    },
    options
  );
};

export const getBillingControllerConfirmSubscriptionMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerConfirmSubscription>>,
    TError,
    { orgId: string; data: ConfirmSubscriptionDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerConfirmSubscription>>,
  TError,
  { orgId: string; data: ConfirmSubscriptionDto },
  TContext
> => {
  const mutationKey = ['billingControllerConfirmSubscription'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerConfirmSubscription>>,
    { orgId: string; data: ConfirmSubscriptionDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerConfirmSubscription(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerConfirmSubscriptionMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerConfirmSubscription>>
>;
export type BillingControllerConfirmSubscriptionMutationBody = ConfirmSubscriptionDto;
export type BillingControllerConfirmSubscriptionMutationError = unknown;

/**
 * @summary Confirm inline subscription after payment succeeds
 */
export const useBillingControllerConfirmSubscription = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerConfirmSubscription>>,
      TError,
      { orgId: string; data: ConfirmSubscriptionDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerConfirmSubscription>>,
  TError,
  { orgId: string; data: ConfirmSubscriptionDto },
  TContext
> => {
  const mutationOptions = getBillingControllerConfirmSubscriptionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create SetupIntent for updating payment method
 */
export const billingControllerCreateSetupIntent = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SetupIntentResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/setup-intent`, method: 'POST', signal },
    options
  );
};

export const getBillingControllerCreateSetupIntentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['billingControllerCreateSetupIntent'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return billingControllerCreateSetupIntent(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerCreateSetupIntentMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>
>;

export type BillingControllerCreateSetupIntentMutationError = unknown;

/**
 * @summary Create SetupIntent for updating payment method
 */
export const useBillingControllerCreateSetupIntent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerCreateSetupIntent>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getBillingControllerCreateSetupIntentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Update payment method after SetupIntent confirmation
 */
export const billingControllerUpdatePaymentMethod = (
  orgId: string,
  updatePaymentMethodDto: UpdatePaymentMethodDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/update-payment-method`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: updatePaymentMethodDto,
      signal,
    },
    options
  );
};

export const getBillingControllerUpdatePaymentMethodMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>,
    TError,
    { orgId: string; data: UpdatePaymentMethodDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>,
  TError,
  { orgId: string; data: UpdatePaymentMethodDto },
  TContext
> => {
  const mutationKey = ['billingControllerUpdatePaymentMethod'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>,
    { orgId: string; data: UpdatePaymentMethodDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerUpdatePaymentMethod(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerUpdatePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>
>;
export type BillingControllerUpdatePaymentMethodMutationBody = UpdatePaymentMethodDto;
export type BillingControllerUpdatePaymentMethodMutationError = unknown;

/**
 * @summary Update payment method after SetupIntent confirmation
 */
export const useBillingControllerUpdatePaymentMethod = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>,
      TError,
      { orgId: string; data: UpdatePaymentMethodDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerUpdatePaymentMethod>>,
  TError,
  { orgId: string; data: UpdatePaymentMethodDto },
  TContext
> => {
  const mutationOptions = getBillingControllerUpdatePaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Create Stripe Customer Portal session
 */
export const billingControllerCreatePortal = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<PortalSessionResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/portal`, method: 'POST', signal },
    options
  );
};

export const getBillingControllerCreatePortalMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerCreatePortal>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerCreatePortal>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['billingControllerCreatePortal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerCreatePortal>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return billingControllerCreatePortal(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerCreatePortalMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerCreatePortal>>
>;

export type BillingControllerCreatePortalMutationError = unknown;

/**
 * @summary Create Stripe Customer Portal session
 */
export const useBillingControllerCreatePortal = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerCreatePortal>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerCreatePortal>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getBillingControllerCreatePortalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Change plan (upgrade immediate with proration, downgrade at next cycle)
 */
export const billingControllerChangePlan = (
  orgId: string,
  changePlanDto: ChangePlanDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ChangePlanResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/change-plan`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: changePlanDto,
      signal,
    },
    options
  );
};

export const getBillingControllerChangePlanMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerChangePlan>>,
    TError,
    { orgId: string; data: ChangePlanDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerChangePlan>>,
  TError,
  { orgId: string; data: ChangePlanDto },
  TContext
> => {
  const mutationKey = ['billingControllerChangePlan'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerChangePlan>>,
    { orgId: string; data: ChangePlanDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerChangePlan(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerChangePlanMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerChangePlan>>
>;
export type BillingControllerChangePlanMutationBody = ChangePlanDto;
export type BillingControllerChangePlanMutationError = unknown;

/**
 * @summary Change plan (upgrade immediate with proration, downgrade at next cycle)
 */
export const useBillingControllerChangePlan = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerChangePlan>>,
      TError,
      { orgId: string; data: ChangePlanDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerChangePlan>>,
  TError,
  { orgId: string; data: ChangePlanDto },
  TContext
> => {
  const mutationOptions = getBillingControllerChangePlanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancel subscription at end of billing period
 */
export const billingControllerCancel = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/cancel`, method: 'POST', signal },
    options
  );
};

export const getBillingControllerCancelMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerCancel>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerCancel>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['billingControllerCancel'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerCancel>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return billingControllerCancel(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerCancelMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerCancel>>
>;

export type BillingControllerCancelMutationError = unknown;

/**
 * @summary Cancel subscription at end of billing period
 */
export const useBillingControllerCancel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerCancel>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerCancel>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getBillingControllerCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get email generation quota for current billing period
 */
export const billingControllerGetQuota = (
  orgId: string,
  params?: BillingControllerGetQuotaParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<QuotaStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/quota`, method: 'GET', params, signal },
    options
  );
};

export const getBillingControllerGetQuotaQueryKey = (
  orgId?: string,
  params?: BillingControllerGetQuotaParams
) => {
  return [`/api/v1/organizations/${orgId}/billing/quota`, ...(params ? [params] : [])] as const;
};

export const getBillingControllerGetQuotaQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetQuota>>,
  TError = unknown,
>(
  orgId: string,
  params?: BillingControllerGetQuotaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetQuotaQueryKey(orgId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetQuota>>> = ({
    signal,
  }) => billingControllerGetQuota(orgId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetQuota>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetQuotaQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetQuota>>
>;
export type BillingControllerGetQuotaQueryError = unknown;

export function useBillingControllerGetQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetQuota>>,
  TError = unknown,
>(
  orgId: string,
  params: undefined | BillingControllerGetQuotaParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetQuota>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetQuota>>,
  TError = unknown,
>(
  orgId: string,
  params?: BillingControllerGetQuotaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetQuota>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetQuota>>,
  TError = unknown,
>(
  orgId: string,
  params?: BillingControllerGetQuotaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get email generation quota for current billing period
 */

export function useBillingControllerGetQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetQuota>>,
  TError = unknown,
>(
  orgId: string,
  params?: BillingControllerGetQuotaParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetQuotaQueryOptions(orgId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get client/brand quota for organization
 */
export const billingControllerGetClientQuota = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ClientQuotaStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/client-quota`, method: 'GET', signal },
    options
  );
};

export const getBillingControllerGetClientQuotaQueryKey = (orgId?: string) => {
  return [`/api/v1/organizations/${orgId}/billing/client-quota`] as const;
};

export const getBillingControllerGetClientQuotaQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetClientQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetClientQuotaQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetClientQuota>>> = ({
    signal,
  }) => billingControllerGetClientQuota(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetClientQuotaQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetClientQuota>>
>;
export type BillingControllerGetClientQuotaQueryError = unknown;

export function useBillingControllerGetClientQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
  TError = unknown,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetClientQuota>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetClientQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetClientQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetClientQuota>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetClientQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetClientQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetClientQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get client/brand quota for organization
 */

export function useBillingControllerGetClientQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetClientQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetClientQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetClientQuotaQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get ESP export quota for current billing period
 */
export const billingControllerGetExportQuota = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ExportQuotaStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/export-quota`, method: 'GET', signal },
    options
  );
};

export const getBillingControllerGetExportQuotaQueryKey = (orgId?: string) => {
  return [`/api/v1/organizations/${orgId}/billing/export-quota`] as const;
};

export const getBillingControllerGetExportQuotaQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetExportQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetExportQuotaQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetExportQuota>>> = ({
    signal,
  }) => billingControllerGetExportQuota(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetExportQuotaQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetExportQuota>>
>;
export type BillingControllerGetExportQuotaQueryError = unknown;

export function useBillingControllerGetExportQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
  TError = unknown,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetExportQuota>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetExportQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetExportQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetExportQuota>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetExportQuota>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetExportQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetExportQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get ESP export quota for current billing period
 */

export function useBillingControllerGetExportQuota<
  TData = Awaited<ReturnType<typeof billingControllerGetExportQuota>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetExportQuota>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetExportQuotaQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Figma plugin entitlement and per-brand billing tiers
 */
export const billingControllerGetFigmaPlugin = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<FigmaPluginStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/figma-plugin`, method: 'GET', signal },
    options
  );
};

export const getBillingControllerGetFigmaPluginQueryKey = (orgId?: string) => {
  return [`/api/v1/organizations/${orgId}/billing/figma-plugin`] as const;
};

export const getBillingControllerGetFigmaPluginQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBillingControllerGetFigmaPluginQueryKey(orgId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>> = ({
    signal,
  }) => billingControllerGetFigmaPlugin(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerGetFigmaPluginQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>
>;
export type BillingControllerGetFigmaPluginQueryError = unknown;

export function useBillingControllerGetFigmaPlugin<
  TData = Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
  TError = unknown,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetFigmaPlugin<
  TData = Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
          TError,
          Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerGetFigmaPlugin<
  TData = Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Figma plugin entitlement and per-brand billing tiers
 */

export function useBillingControllerGetFigmaPlugin<
  TData = Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof billingControllerGetFigmaPlugin>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerGetFigmaPluginQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Grants the organization its free Figma imports. Idempotent: a second call leaves the original grant alone, so what has already been spent cannot be refilled. Returns the same status shape as GET figma-plugin, so the caller can read the remaining count straight back.
 * @summary Start the free Figma imports for this organization
 */
export const billingControllerStartFigmaTrial = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<FigmaPluginStatusResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/figma-plugin/trial`, method: 'POST', signal },
    options
  );
};

export const getBillingControllerStartFigmaTrialMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['billingControllerStartFigmaTrial'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return billingControllerStartFigmaTrial(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerStartFigmaTrialMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>
>;

export type BillingControllerStartFigmaTrialMutationError = unknown;

/**
 * @summary Start the free Figma imports for this organization
 */
export const useBillingControllerStartFigmaTrial = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerStartFigmaTrial>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getBillingControllerStartFigmaTrialMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Preview what a promotion code takes off White Glove
 */
export const billingControllerPreviewWhiteGlovePromotion = (
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<WhiteGlovePromotionPreviewDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/white-glove/promotion`,
      method: 'GET',
      params,
      signal,
    },
    options
  );
};

export const getBillingControllerPreviewWhiteGlovePromotionQueryKey = (
  orgId?: string,
  params?: BillingControllerPreviewWhiteGlovePromotionParams
) => {
  return [
    `/api/v1/organizations/${orgId}/billing/white-glove/promotion`,
    ...(params ? [params] : []),
  ] as const;
};

export const getBillingControllerPreviewWhiteGlovePromotionQueryOptions = <
  TData = Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
  TError = unknown,
>(
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getBillingControllerPreviewWhiteGlovePromotionQueryKey(orgId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>
  > = ({ signal }) =>
    billingControllerPreviewWhiteGlovePromotion(orgId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BillingControllerPreviewWhiteGlovePromotionQueryResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>
>;
export type BillingControllerPreviewWhiteGlovePromotionQueryError = unknown;

export function useBillingControllerPreviewWhiteGlovePromotion<
  TData = Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
  TError = unknown,
>(
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
          TError,
          Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerPreviewWhiteGlovePromotion<
  TData = Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
  TError = unknown,
>(
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
          TError,
          Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBillingControllerPreviewWhiteGlovePromotion<
  TData = Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
  TError = unknown,
>(
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Preview what a promotion code takes off White Glove
 */

export function useBillingControllerPreviewWhiteGlovePromotion<
  TData = Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
  TError = unknown,
>(
  orgId: string,
  params: BillingControllerPreviewWhiteGlovePromotionParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof billingControllerPreviewWhiteGlovePromotion>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getBillingControllerPreviewWhiteGlovePromotionQueryOptions(
    orgId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set each brand's billing tier. Upgrades apply now; downgrades at period end.
 */
export const billingControllerSetBrandTiers = (
  orgId: string,
  setBrandTiersDto: SetBrandTiersDto,
  options?: SecondParameter<typeof authFetch>
) => {
  return authFetch<SetBrandTiersResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/figma-plugin/brands`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: setBrandTiersDto,
    },
    options
  );
};

export const getBillingControllerSetBrandTiersMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerSetBrandTiers>>,
    TError,
    { orgId: string; data: SetBrandTiersDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerSetBrandTiers>>,
  TError,
  { orgId: string; data: SetBrandTiersDto },
  TContext
> => {
  const mutationKey = ['billingControllerSetBrandTiers'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerSetBrandTiers>>,
    { orgId: string; data: SetBrandTiersDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerSetBrandTiers(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerSetBrandTiersMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerSetBrandTiers>>
>;
export type BillingControllerSetBrandTiersMutationBody = SetBrandTiersDto;
export type BillingControllerSetBrandTiersMutationError = unknown;

/**
 * @summary Set each brand's billing tier. Upgrades apply now; downgrades at period end.
 */
export const useBillingControllerSetBrandTiers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerSetBrandTiers>>,
      TError,
      { orgId: string; data: SetBrandTiersDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerSetBrandTiers>>,
  TError,
  { orgId: string; data: SetBrandTiersDto },
  TContext
> => {
  const mutationOptions = getBillingControllerSetBrandTiersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Returns the client secret for an add-on subscription that was started and never paid for. `clientSecret` is null when there is nothing owing -- no line, already paid, or expired and needing a fresh purchase.
 * @summary Resume an unfinished add-on purchase
 */
export const billingControllerResumeAddonPayment = (
  orgId: string,
  slug: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ResumeAddonPaymentResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/addons/${slug}/resume-payment`,
      method: 'POST',
      signal,
    },
    options
  );
};

export const getBillingControllerResumeAddonPaymentMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>,
    TError,
    { orgId: string; slug: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>,
  TError,
  { orgId: string; slug: string },
  TContext
> => {
  const mutationKey = ['billingControllerResumeAddonPayment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>,
    { orgId: string; slug: string }
  > = (props) => {
    const { orgId, slug } = props ?? {};

    return billingControllerResumeAddonPayment(orgId, slug, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerResumeAddonPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>
>;

export type BillingControllerResumeAddonPaymentMutationError = unknown;

/**
 * @summary Resume an unfinished add-on purchase
 */
export const useBillingControllerResumeAddonPayment = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>,
      TError,
      { orgId: string; slug: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerResumeAddonPayment>>,
  TError,
  { orgId: string; slug: string },
  TContext
> => {
  const mutationOptions = getBillingControllerResumeAddonPaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Confirm an add-on subscription after payment succeeds
 */
export const billingControllerConfirmAddon = (
  orgId: string,
  confirmAddonDto: ConfirmAddonDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/addons/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmAddonDto,
      signal,
    },
    options
  );
};

export const getBillingControllerConfirmAddonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerConfirmAddon>>,
    TError,
    { orgId: string; data: ConfirmAddonDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerConfirmAddon>>,
  TError,
  { orgId: string; data: ConfirmAddonDto },
  TContext
> => {
  const mutationKey = ['billingControllerConfirmAddon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerConfirmAddon>>,
    { orgId: string; data: ConfirmAddonDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return billingControllerConfirmAddon(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerConfirmAddonMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerConfirmAddon>>
>;
export type BillingControllerConfirmAddonMutationBody = ConfirmAddonDto;
export type BillingControllerConfirmAddonMutationError = unknown;

/**
 * @summary Confirm an add-on subscription after payment succeeds
 */
export const useBillingControllerConfirmAddon = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerConfirmAddon>>,
      TError,
      { orgId: string; data: ConfirmAddonDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerConfirmAddon>>,
  TError,
  { orgId: string; data: ConfirmAddonDto },
  TContext
> => {
  const mutationOptions = getBillingControllerConfirmAddonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Cancel the Figma add-on at the end of the billing period
 */
export const billingControllerCancelFigmaAddon = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<MessageResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/figma-plugin/cancel`, method: 'POST', signal },
    options
  );
};

export const getBillingControllerCancelFigmaAddonMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>,
    TError,
    { orgId: string },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationKey = ['billingControllerCancelFigmaAddon'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>,
    { orgId: string }
  > = (props) => {
    const { orgId } = props ?? {};

    return billingControllerCancelFigmaAddon(orgId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type BillingControllerCancelFigmaAddonMutationResult = NonNullable<
  Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>
>;

export type BillingControllerCancelFigmaAddonMutationError = unknown;

/**
 * @summary Cancel the Figma add-on at the end of the billing period
 */
export const useBillingControllerCancelFigmaAddon = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>,
      TError,
      { orgId: string },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof billingControllerCancelFigmaAddon>>,
  TError,
  { orgId: string },
  TContext
> => {
  const mutationOptions = getBillingControllerCancelFigmaAddonMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get the Shopify-hosted plan selection URL for a Shopify-billed org
 */
export const shopifyBillingControllerGetSubscribeUrl = (
  orgId: string,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ShopifySubscribeUrlResponseDto>(
    { url: `/api/v1/organizations/${orgId}/billing/shopify/subscribe-url`, method: 'GET', signal },
    options
  );
};

export const getShopifyBillingControllerGetSubscribeUrlQueryKey = (orgId?: string) => {
  return [`/api/v1/organizations/${orgId}/billing/shopify/subscribe-url`] as const;
};

export const getShopifyBillingControllerGetSubscribeUrlQueryOptions = <
  TData = Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getShopifyBillingControllerGetSubscribeUrlQueryKey(orgId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>
  > = ({ signal }) => shopifyBillingControllerGetSubscribeUrl(orgId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!orgId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ShopifyBillingControllerGetSubscribeUrlQueryResult = NonNullable<
  Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>
>;
export type ShopifyBillingControllerGetSubscribeUrlQueryError = unknown;

export function useShopifyBillingControllerGetSubscribeUrl<
  TData = Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
  TError = unknown,
>(
  orgId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
          TError,
          Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useShopifyBillingControllerGetSubscribeUrl<
  TData = Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
          TError,
          Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useShopifyBillingControllerGetSubscribeUrl<
  TData = Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the Shopify-hosted plan selection URL for a Shopify-billed org
 */

export function useShopifyBillingControllerGetSubscribeUrl<
  TData = Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
  TError = unknown,
>(
  orgId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof shopifyBillingControllerGetSubscribeUrl>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getShopifyBillingControllerGetSubscribeUrlQueryOptions(orgId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Confirm a Shopify subscription after the merchant approves the plan
 */
export const shopifyBillingControllerConfirm = (
  orgId: string,
  confirmShopifyBillingDto: ConfirmShopifyBillingDto,
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<ShopifyBillingStatusResponseDto>(
    {
      url: `/api/v1/organizations/${orgId}/billing/shopify/confirm`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: confirmShopifyBillingDto,
      signal,
    },
    options
  );
};

export const getShopifyBillingControllerConfirmMutationOptions = <
  TError = unknown,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>,
    TError,
    { orgId: string; data: ConfirmShopifyBillingDto },
    TContext
  >;
  request?: SecondParameter<typeof authFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>,
  TError,
  { orgId: string; data: ConfirmShopifyBillingDto },
  TContext
> => {
  const mutationKey = ['shopifyBillingControllerConfirm'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>,
    { orgId: string; data: ConfirmShopifyBillingDto }
  > = (props) => {
    const { orgId, data } = props ?? {};

    return shopifyBillingControllerConfirm(orgId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ShopifyBillingControllerConfirmMutationResult = NonNullable<
  Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>
>;
export type ShopifyBillingControllerConfirmMutationBody = ConfirmShopifyBillingDto;
export type ShopifyBillingControllerConfirmMutationError = unknown;

/**
 * @summary Confirm a Shopify subscription after the merchant approves the plan
 */
export const useShopifyBillingControllerConfirm = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>,
      TError,
      { orgId: string; data: ConfirmShopifyBillingDto },
      TContext
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof shopifyBillingControllerConfirm>>,
  TError,
  { orgId: string; data: ConfirmShopifyBillingDto },
  TContext
> => {
  const mutationOptions = getShopifyBillingControllerConfirmMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
